import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const STATES = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA',
  'PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'
];

export const ProfileUserFields = ({ state, setState, city, citySearch, setCitySearch, setCity, showCitySuggestions, setShowCitySuggestions, filteredCities, handleCitySelect, cityRef }) => (
  <div className="space-y-4 pt-2 border-t border-slate-200">
    <div>
      <Label>Estado</Label>
      <Select value={state} onValueChange={setState}>
        <SelectTrigger className="mt-1" data-testid="user-state-select"><SelectValue placeholder="Selecione" /></SelectTrigger>
        <SelectContent>{STATES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
      </Select>
    </div>
    <div className="relative" ref={cityRef}>
      <Label>Cidade</Label>
      <Input value={citySearch || city} onChange={e => { setCitySearch(e.target.value); setCity(''); setShowCitySuggestions(true); }}
        onFocus={() => setShowCitySuggestions(true)} placeholder={state ? "Digite a cidade..." : "Selecione o estado primeiro"}
        disabled={!state} required data-testid="user-city-input" className="mt-1" />
      {showCitySuggestions && filteredCities.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
          {filteredCities.map(c => (
            <button key={c} type="button" onClick={() => handleCitySelect(c)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 transition-colors" data-testid={`city-option-${c}`}>{c}</button>
          ))}
        </div>
      )}
    </div>
  </div>
);
